
import {
    Component,
    ContentChildren,
    QueryList
} from '@angular/core';
import { TabComponent } from './tab/tab.component';

@Component({
    selector: 'tabset',
    templateUrl: './tabset.component.html',
    standalone: false
})

export class TabsetComponent {

    @ContentChildren(TabComponent)
    tabsQuery!: QueryList<TabComponent>;
    tabs: TabComponent[] = [];

    addTab(_: TabComponent) {
        // Tabs auto registered by ContentChildren
    }

    activateTab(tab: TabComponent) {
        this.tabs.forEach(t => {
            if (t === tab) t.activate();
            else t.deactivate();
        });
    }

    ngAfterContentInit() {
        this.updateTabs();
        this.tabsQuery.changes.subscribe(() => this.updateTabs());
    }

    private updateTabs() {
        this.tabs = this.tabsQuery.toArray();
    }
}